import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { Medal } from "@/components/badges/Medal";

const COLORS = ["#F59E0B", "#B45309", "#047857", "#8B3A2B", "#FDE68A", "#60A5FA"];
const PIECES = Array.from({ length: 28 }, (_, i) => ({
  x: Math.cos((i / 28) * Math.PI * 2) * (90 + (i % 4) * 30),
  y: Math.sin((i / 28) * Math.PI * 2) * (70 + (i % 3) * 30),
  c: COLORS[i % COLORS.length], r: (i * 47) % 360,
}));

export const BadgeCelebration = () => {
  const { user } = useAuth();
  const { t, isRtl } = useLang();
  const [level, setLevel] = useState(0);
  const isStudent = user?.role === "user" && user?.is_active;

  useEffect(() => {
    if (!isStudent) { setLevel(0); return; }
    api.get("/my/stars").then((r) => {
      const lv = r.data?.level ?? 0;
      if (lv > (r.data?.seen ?? 0)) setLevel(lv);
    }).catch(() => {});
  }, [isStudent, user?.id]);

  const close = () => { setLevel(0); api.post("/my/stars/seen").catch(() => {}); };
  const i = level - 1;

  return (
    <Dialog open={level > 0} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent dir={isRtl ? "rtl" : "ltr"} className="max-w-[92vw] sm:max-w-sm bg-[#FAF7F2] border-[#E5DCCB] rounded-sm text-center overflow-hidden" data-testid="badge-celebration">
        {level > 0 && (
          <div className="relative h-44 grid place-items-center">
            {PIECES.map((p, k) => (
              <motion.span key={k} className="absolute w-2 h-3 rounded-sm" style={{ background: p.c }}
                initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 0.4 }}
                animate={{ x: p.x, y: p.y, opacity: 0, rotate: p.r, scale: 1 }}
                transition={{ duration: 1.6, delay: 0.25, ease: "easeOut" }} />
            ))}
            <motion.div initial={{ scale: 0, rotate: -30 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 220, damping: 12 }}>
              <Medal i={i} size={112} testId="badge-celebration-medal" />
            </motion.div>
          </div>
        )}
        <DialogTitle className="font-display text-3xl text-center">{t.badges.congrats}</DialogTitle>
        <DialogDescription asChild>
          <div className="space-y-1 text-center">
            <p className="text-lg font-semibold text-[#1C1917]" data-testid="badge-celebration-text">{level > 0 && t.badges.earned(t.badges.names[i])}</p>
            <p className="text-stone-600">{t.badges.keep}</p>
          </div>
        </DialogDescription>
        <button onClick={close} data-testid="badge-celebration-ok"
          className="mt-2 mx-auto rounded-full bg-[#1C1917] text-[#FAF7F2] px-8 py-3 font-semibold hover:bg-[#3B2F25] transition-colors">{t.badges.ok}</button>
      </DialogContent>
    </Dialog>
  );
};
